module.exports = "https://static.zego.com/_next/static/images/Backdrop-cb9275117374c09f562e5fdfcef9a2c5.svg";